"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessHighchartsSettingsFilterFrequencyComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const use_custom_compare_1 = require("use-custom-compare");
const StickinessPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageDataProvider");
const StickinessChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessChartSettingsJSONModel");
const dropdownItemRender = (text, key, selectedValues) => {
    const iconShow = lodash_1.default.includes(selectedValues, key) ? "visible" : "hidden";
    return { key: key, label: React.createElement(antd_1.Row, null,
            React.createElement(antd_1.Col, { className: "multiSelectDropdownItemLabel" }, text),
            React.createElement(antd_1.Col, { className: "multiSelectDropdownItemSelectedIcon", flex: "auto", style: { visibility: iconShow } },
                React.createElement(icons_1.CheckOutlined, null))) };
};
const getMenuItemLabels = (periods, lineType) => {
    return lodash_1.default.map(periods, (value) => {
        switch (lineType) {
            case LineTypeJSONModel_1.LineType.nonCumulative:
                return [value, `${value}/${periods.length}`];
            case LineTypeJSONModel_1.LineType.cumulative:
                return [value, `≥${value}/${periods.length}`];
        }
    });
};
const StickinessHighchartsSettingsFilterFrequencyComponent = () => {
    var _a, _b;
    const stickinessPageDataContext = (0, StickinessPageDataProvider_1.useStickinessPageDataContext)();
    const { inProgress, loaded } = stickinessPageDataContext.state.status;
    const { isError } = stickinessPageDataContext.state.error;
    const disabled = inProgress || isError || !loaded || lodash_1.default.isNil(stickinessPageDataContext.state.data);
    const periods = Array.from(((_b = (_a = stickinessPageDataContext.state.data) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.periods) || []);
    const jsonModel = stickinessPageDataContext.stateFns.getURLJSONModel();
    const filterFrequency = jsonModel.getChartSettingsJSONModel().getFilterFrequency();
    const lineType = jsonModel.getLineTypeJSONModel().getLineType();
    const [popupVisible, setPopupVisible] = (0, react_1.useState)(false);
    const filterOvertimeFrequencyOnChange = (0, use_custom_compare_1.useCustomCompareCallback)((clickedMenuKey) => {
        const chartSettingsJSONModel = stickinessPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel();
        const filterFrequency = chartSettingsJSONModel.getFilterFrequency();
        const clickedMenuKeyAsNumber = lodash_1.default.toNumber(clickedMenuKey);
        if (lodash_1.default.isFinite(clickedMenuKeyAsNumber)) {
            if (lodash_1.default.includes(filterFrequency, clickedMenuKeyAsNumber)) {
                lodash_1.default.remove(filterFrequency, e => e === clickedMenuKeyAsNumber);
            }
            else {
                filterFrequency.push(clickedMenuKeyAsNumber);
            }
        }
        chartSettingsJSONModel.setFilterFrequency(filterFrequency);
        stickinessPageDataContext.stateFns.onChartSettingsChanged(chartSettingsJSONModel.serialize());
    }, [stickinessPageDataContext.stateFns], lodash_1.default.isEqual);
    const onClickMenu = (0, react_1.useCallback)(({ key }) => {
        filterOvertimeFrequencyOnChange(key);
    }, [filterOvertimeFrequencyOnChange]);
    const dropdownRender = (0, react_1.useCallback)((periods, filterFrequency, lineType) => {
        const selectedValues = lodash_1.default.sortBy(filterFrequency);
        const selectedValuesStrings = lodash_1.default.map(selectedValues, lodash_1.default.toString);
        const selectOptionsLabels = getMenuItemLabels(periods, lineType);
        const items = selectOptionsLabels.map((value) => {
            return dropdownItemRender(React.createElement(React.Fragment, null, value[1]), value[0], selectedValues);
        });
        return React.createElement(antd_1.Menu, { multiple: true, className: "multiSelectDropdown multiSelectDropdownComponent", selectedKeys: selectedValuesStrings, onClick: onClickMenu, items: items });
    }, [onClickMenu]);
    const onPopupVisibleChange = (popupVisible) => setPopupVisible(popupVisible);
    const overlay = dropdownRender(periods, filterFrequency, lineType);
    const isActive = !(0, StickinessChartSettingsJSONModel_1.isDefaultFilterFrequency)(filterFrequency);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Dropdown, { overlay: overlay, disabled: disabled, placement: "bottomRight", trigger: ["click"], className: `appMultiSelectComponent${popupVisible ? " appMultiSelectComponentActive" : ""}`, visible: popupVisible, onVisibleChange: onPopupVisibleChange },
            React.createElement(antd_1.Button, { icon: React.createElement(icons_1.FilterOutlined, null), disabled: disabled, type: isActive ? "primary" : "default" })));
};
exports.StickinessHighchartsSettingsFilterFrequencyComponent = StickinessHighchartsSettingsFilterFrequencyComponent;
